module.exports = __webpack_public_path__ + "media/images/home/ny_picsel-51d9ae3b95ff4d390d89cba4993e0488.png";